import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import {
  academicPerformance,
  acdemicProgram,
  admissions,
  bell,
  calendarEvents,
  calenderEvent,
  classes,
  dashboard,
  daycareLog,
  dropDown,
  exams,
  feedback,
  feesPayment,
  formsRequest,
  FranchiseInsights,
  group,
  HelpDesk,
  location,
  logo,
  logout,
  mediaGallary,
  menu,
  messages,
  noticeBoard,
  payroll,
  queries,
  records,
  reports,
  schedulePtm,
  schoolExpenses,
  section,
  staff,
  students,
  timeTable,
} from "../asset";
import { popupNavigation } from "../util/functions/UniversalFunctions";
import TooltipWrapper from "./TooltipWrapper";
import { useSelector } from "react-redux";
import { RootState } from "../store";
import BranchSelector from "./common/BranchSelector";
import { IS_LIVE } from "../util/config/env";

export const menuSections = [
  {
    title: "GENERAL",
    links: [
      { name: "Dashboard", icon: dashboard, path: "/" },
      // { name: "Feedbacks", icon: feedback, path: "/feedbacks" },
    ],
  },
  {
    title: "INSTITUTE MANAGEMENT",
    links: [
      { name: "Staff", icon: staff, path: "/staff" },
      { name: "Students", icon: students, path: "/all-students" },
      { name: "Classes", icon: classes, path: "/classes" },
      // { name: "Sections", icon: section, path: "/sections" },
      { name: "Groups/Houses", icon: group, path: "/groups-houses" },
      {
        name: "Admissions",
        icon: admissions,
        path: "/admissions",
      },
      { name: "Queries", icon: queries, path: "/queries" },
      { name: "Schedule PTM", icon: schedulePtm, path: "/ptm-list" },
      // {
      //   name: "Records & Archives",
      //   icon: records,
      //   path: "/records",
      // },
      { name: "Messages", icon: messages, path: "/messages" },
      // { name: "Notice Board", icon: noticeBoard, path: "/notice-board" }, // untill app is readyy
      {
        name: "Academic Preferences",
        icon: academicPerformance,
        path: "/academic-preferences",
      },
    ],
  },
  {
    title: "UTILITIES",
    links: [
      {
        name: "Fees & Payments",
        icon: feesPayment,
        path: "/fees-and-payments",
      },
      {
        name: "Payroll Management",
        icon: payroll,
        path: "/payroll-management",
      },
      {
        name: "Calendar & Events",
        icon: calenderEvent,
        path: "/calendar-and-events",
      },
      {
        name: "Timetable",
        icon: timeTable,
        path: "/timetable",
        underDevelopment: false,
      },
      // {
      //   name: "Academic Programs",
      //   icon: acdemicProgram,
      //   path: "/programs",
      // },
      // {
      //   name: "School Expenses",
      //   icon: schoolExpenses,
      //   path: "/expenses",
      // },
      // {
      //   name: "Calendar & Events",
      //   icon: calendarEvents,
      //   path: "/calendar",
      // },
      // {
      //   name: "Daycare Log",
      //   icon: daycareLog,
      //   path: "/daycare-log",
      // },
      {
        name: "Exams & Assignments",
        icon: exams,
        path: "/exams-and-assignments",
      },
      {
        name: "Forms",
        icon: formsRequest,
        path: "/forms",
      },
      { name: "Media Gallery", icon: mediaGallary, path: "/media-gallery" },
      // { name: "Reports", icon: reports, path: "/reports" },
    ],
  },
  {
    title: "MISC",
    links: [
      { name: "Help Desk", icon: HelpDesk, path: "/help" },
      // {
      //   name: "Franchise Insights",
      //   icon: FranchiseInsights,
      //   path: "/franchise-insights",
      // },
      // { name: "Logout", icon: logout, path: popupNavigation("logout") },
    ],
  },
];

export const featureIdMap: Record<string, number> = {
  Staff: 1,
  Admissions: 2, // Admission & Queries
  Queries: 2, // same feature
  Messages: 3, // Messaging
  "Notice Board": 4,
  "Fees & Payments": 5,
  "Payroll Management": 6,
  "Calendar & Events": 7,
  "Media Gallery": 8, // Media
  "Video Sharing": 8,
  // Leave Management (10) -> not in sidebar
};

export default function Sidebar({ isOpen, onClose }) {
  const navigate = useNavigate();
  const school = useSelector((state: RootState) => state.access.schoolBranch);
  const features = useSelector((state: RootState) => state.access.features);
  const user = useSelector((state: RootState) => state.access.staff);

  const isFeatureEnabled = (menuName: string) => {
    if (menuName === "Academic Preferences") {
      return (
        user?.roleName === "ROLE_ADMIN" || user?.roleName === "ROLE_SUPER_ADMIN"
      );
    }

    const featureId = featureIdMap[menuName];

    // If no featureId mapped → always show (like Dashboard, Students, etc.)
    if (!featureId) return true;

    return features.some(
      (feature) => feature.featuresId === featureId && feature.active
    );
  };

  return (
    <>
      {/* Overlay for mobile */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40 xl:hidden"
          onClick={onClose}
        />
      )}

      {/* Sidebar */}
      <aside
        className={`
        w-64 max-h-screen pt-9 gap-9 bg-white justify-center md:items-center flex flex-col
        xl:relative xl:translate-x-0
        fixed top-0 right-0 h-full z-50 transition-transform duration-300 ease-in-out
        ${isOpen ? "translate-x-0" : "translate-x-full xl:translate-x-0"}
      `}>
        {/* Close button for mobile */}
        <button
          onClick={onClose}
          className="absolute top-4 left-0 right-0 flex items-center justify-between px-4 text-neutral-400 hover:text-neutral-600 xl:hidden">
          <img src={menu} alt="menu" className="w-8 h-8" />
          <img src={bell} alt="bell" className="md:hidden w-6 h-6" />
        </button>

        {/* ===== Sidebar Header ===== */}
        <div className="md:flex justify-center hidden items-center">
          <img src={school?.schoolBranchIcon} alt="logo" className="w-44" />
        </div>

        {/* ===== Sidebar Menu ===== */}
        <div className="flex justify-start items-start pt-6 pl-4 md:hidden">
          <BranchSelector />
        </div>

        <nav className="flex-1 overflow-y-auto pl-4 xl:pl-4 p-3 space-y-7 custom-scrollbar">
          {menuSections.map((section) => (
            <div key={section.title} className="space-y-3">
              <h2 className="text-xs font-medium text-neutral-300 px-2 mb-2 uppercase">
                {section.title}
              </h2>

              <ul className="space-y-2">
                {section.links
                  .filter((link) => isFeatureEnabled(link.name))
                  .map((link) => {
                    const isLockedInLive =
                      IS_LIVE &&
                      [
                        // "Timetable",
                        "Exams & Assignments",
                        // "Dashboard",
                      ].includes(link.name);
                    return (
                      <li key={link.name} className="relative group">
                        {link.underDevelopment || isLockedInLive ? (
                          <div className="flex items-center gap-3 px-5 py-2 rounded-md text-[13px] text-neutral-400 cursor-not-allowed">
                            <img
                              src={link.icon}
                              alt={link.name}
                              className="w-4 h-4"
                            />
                            <span>{link.name}</span>
                            {/* Hover badge */}
                            <span className="ml-auto bg-background-500 text-neutral-500 text-nowrap text-[10px] px-2 py-0.5 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-150">
                              Coming Soon
                            </span>
                          </div>
                        ) : (
                          <NavLink
                            to={link.path}
                            onClick={() => {
                              if (window.innerWidth < 1280) {
                                onClose();
                              }
                            }}
                            className={({ isActive }) =>
                              `flex items-center gap-3 px-5 py-2 rounded-md text-[13px] transition-all duration-150 ${
                                isActive
                                  ? "bg-primary-50 text-primary-500 font-semibold"
                                  : "text-neutral-400 hover:bg-primary-50 font-normal"
                              }`
                            }>
                            <img
                              src={link.icon}
                              alt={link.name}
                              className="w-4 h-4"
                            />
                            <span>{link.name}</span>
                          </NavLink>
                        )}
                      </li>
                    );
                  })}
                {section.title === "MISC" && (
                  <li>
                    <button
                      onClick={() => navigate(popupNavigation("logout"))}
                      className="flex items-center w-full gap-3 px-5 py-2 rounded-md text-sm text-neutral-400 hover:bg-primary-50">
                      <img src={logout} alt="Logout" className="w-4 h-4" />
                      <span>Logout</span>
                    </button>
                  </li>
                )}
              </ul>
            </div>
          ))}
        </nav>
      </aside>
    </>
  );
}
